import { PostmasterIntegrationContent } from "@/components/profile/postmaster-integration";
import ApiKeySection from "@/pages/api-key";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_private/integration")({
  component: Integration,
});

function Integration() {
  return (
    <div className="w-full space-y-6">
      <PostmasterIntegrationContent />
      {/* <ApiKeySection /> */}
    </div>
  );
}
